import { _Types, getServerData } from "@reactivated";

import { getJSONScriptData } from "@thelabnyc/thelabui/src/utils/dom";

export const IS_PUPPETEER =
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("HeadlessChrome");

export type ReactivatedContext = Readonly<_Types["Context"]>;

let _context: ReactivatedContext | null = null;

export const getReactivatedContext = (): ReactivatedContext | null => {
    if (!_context) {
        if (
            typeof window !== "undefined" &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).__PRELOADED_CONTEXT__
        ) {
            _context = getServerData().context;
        } else if (typeof document !== "undefined") {
            _context = getJSONScriptData(
                "thelabui-react-context",
            ) as ReactivatedContext | null;
        }
    }
    return _context;
};
